import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ab0ebf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-card lp-next" }
const _hoisted_2 = { class: "lp-next__title" }
const _hoisted_3 = { class: "lp-next__resource" }
const _hoisted_4 = {
  class: "lp-next__icon",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "lp-next__info" }
const _hoisted_6 = { class: "lp-next__name" }
const _hoisted_7 = {
  key: 0,
  class: "lp-next__meta"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))

import { computed } from 'vue';
import {
  IResources,
  resourceHref,
  resourceKind,
  resourceLevel,
  resourceTitle,
  useLearningPathI18n,
} from './learningPath';


export default /*#__PURE__*/_defineComponent({
  props: {
    resource: null,
    pathwayId: null
  },
  setup(__props: any) {

const props = __props as {
  resource: IResources
  pathwayId: string
}



const { tl } = useLearningPathI18n();

const kind = computed(() => resourceKind(props.resource));
const href = computed(() => resourceHref(props.pathwayId, props.resource));
const level = computed(() => resourceLevel(props.resource));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(tl)('next_challenge')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("i", {
          class: _normalizeClass(_unref(kind) === 'machine' ? 'bi bi-display' : 'bi bi-terminal')
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(tl)(`type_${_unref(kind)}`)) + ": " + _toDisplayString(_unref(resourceTitle)(__props.resource)), 1),
        (_unref(level))
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(tl)(`level_${_unref(level)}`)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(href))
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _unref(href),
          target: "_blank",
          class: "lp-btn lp-btn--block"
        }, [
          _createTextVNode(_toDisplayString(_unref(tl)('continue_challenge')) + " ", 1),
          _hoisted_9
        ], 8, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}
}

})